import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { inject, observer } from "mobx-react";
import green from '@material-ui/core/colors/green';
import Paper from '@material-ui/core/Paper';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import Favorite from '@material-ui/icons/Favorite';
import FavoriteBorder from '@material-ui/icons/FavoriteBorder';
import Typography from '@material-ui/core/Typography';


function jsUcfirst(string) 
{
    return string.charAt(0).toUpperCase() + string.slice(1);
}

const styles = theme => ({
  root: {
    flexGrow: 1, 
    margin: theme.spacing.unit * 2,
  },
});

@inject("commonStore")
@observer
class Conditions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        value: 0,
    }
  }
  update = (value) => {
    console.log('update')
    console.log(value)
    const { leadType, qualifier, contact, filters, updateFilters } = this.props
    const filterArray = filters[leadType]['qualifiers'][qualifier][contact]

    let updated = false
    const updateFilterArray = filterArray.map((item) => {
        if(item.field === 'condition'){
          updated = true
          const index = item.include.indexOf(value)
          let { include } = item
      
          if(index > -1){
            include = include.filter((item) => {
              return value !== item
            })
          }else{
            include.push(value)
          }
          item.include = [...include]
        }
       return item
    })
    const newFilters = {...filters}

    if(!updated){
      newFilters[leadType]['qualifiers'][qualifier][contact].push({
        "field": "condition",
        "include": [value],
      })
    }else{
      newFilters[leadType]['qualifiers'][qualifier][contact] = updateFilterArray
    }

    updateFilters(newFilters)
    
  }
  makeLabel = (value) => {
      const splitArray = value.split('_')
      if(splitArray.length > 1){
        return `${jsUcfirst(splitArray[0])} ${jsUcfirst(splitArray[1])}`
      }
      return jsUcfirst(value)
  }
  makeOptions = () => {

    const { filters, leadType, qualifier, contact, conditionsAllowed } = this.props
    console.log(this.props)
    console.log(qualifier)
    
    const filterArray = filters[leadType]['qualifiers'][qualifier][contact]
    
    console.log(filterArray)
    
    const updateFilterArray = filterArray.filter((item) => {
          return item.field === 'condition'
    })
    
    let conditions = []
    
    if(updateFilterArray.length > 0){
      console.log(updateFilterArray)
      conditions = updateFilterArray[0].include
    }


        return conditionsAllowed.map(condition => {
                return (
                  <FormControlLabel
                  key={condition}
                  control={
                    <Checkbox
                      key={condition}
                      disabled={qualifier === 'split_policy' && condition === 'none'}
                      checked={conditions.includes(condition)}
                      onChange={() => this.update(condition)}
                      value={condition}
                      color="primary"
                    />
                  }
                  label={this.makeLabel(condition)}
                />
              )
        })
    }

  

  render() {
    const { classes, qualifier, contact } = this.props
    return (
      <div className={classes.root}>
      <Typography className={classes.title} variant="h5">  {`Step 4: ${this.makeLabel(qualifier)} / ${this.makeLabel(contact)} Conditions`}</Typography>
        {this.makeOptions()}
      </div>
    );
  }
}

Conditions.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Conditions);


// WEBPACK FOOTER //
// ./src/components/Leads/Campaigns/ManageCampaign/Options/Filters/Tiered/Filters/Conditions.js